const CRITICAL_KEYS = ['token', 'user', 'language', 'pages', 'sources', 'bots', 'groups', 'clarityConsent']

const EVICTABLE_TIERS = [
  [
    'users', 'posts', 'optimalTimes', 'reportingConcurrences',
    'synchronizedPosts', 'pins', 'postPreviewData', 'storificationPreviewData', 'userData',
  ],
  [
    'inboxFilter', 'inbox_filter', 'section', 'tab', 'typeCalendar', 'currentViewType',
    'showEmptySlots', 'hideGroups', 'lastPageReporting', 'last_selected_page', 'last_selected_pages',
    'postCreator', 'draft', 'draftToRestore', 'last_post_draft',
    'badWordList', 'hashtagsAdded', 'mentionsAdded',
    'activeHashtagsAutoAdd', 'activeMentionsAutoReplace', 'activePrefixSuffix', 'optionValidation',
  ],
  [
    'onboardingCompleted', 'onboardingSkipped', 'onboarding_current_index',
    'onboarding_current_network', 'onboarding_mode', 'onboarding_native_state',
    'onboarding_pages_before_extension', 'onboarding_selected_features',
    'onboarding_selected_networks', 'onboarding_state', 'onboarding_summary_refresh',
    'mashup_onboarding_context', 'instagram_adding_page', 'linkedin_adding_page',
    'tiktok_adding_page', 'twitter_adding_page', 'threads_adding_page',
    'youtube_adding_page', 'refresh_twitter_page',
  ],
]

const _storage = window.localStorage
const _set = (k, v) => Storage.prototype.setItem.call(_storage, k, v)
const _get = (k) => Storage.prototype.getItem.call(_storage, k)

export function slimPage(p) {
  if (!p || typeof p !== 'object') return p
  return {
    id: p.id,
    network: p.network,
    name: p.name,
    avatar: p.avatar,
    network_id: p.network_id,
    story_config: p.story_config,
    isGroup: p.isGroup,
    instagram_username: p.instagram_username,
    bot_status: p.bot_status,
    groups: p.groups,
    natifMode: p.natifMode,
    affected_to: p.affected_to,
    reporting: p.reporting
      ? { updated_at: p.reporting.updated_at, last_refreshed_at: p.reporting.last_refreshed_at }
      : undefined,
  }
}

export function slimBot(b) {
  if (!b || typeof b !== 'object') return b
  return {
    id: b.id,
    name: b.name,
    service: b.service,
    category: b.category,
    domain: b.domain,
    flux: b.flux,
    frequency: b.frequency,
    instant: b.instant,
    status: b.status,
    uid: b.uid,
    type: b.type,
    mode: b.mode,
    storyTemplate: b.storyTemplate,
    post_text_layout: b.post_text_layout,
    hashtagPrefix: b.hashtagPrefix,
    hashtag: b.hashtag,
    linkInComments: b.linkInComments,
    positionlink: b.positionlink,
    mentions: b.mentions,
    hashtagsAuto: b.hashtagsAuto,
    utm_source: b.utm_source,
    updated_at: b.updated_at,
    planning: b.planning,
    error_msg: b.error_msg,
    expires_at: b.expires_at,
    page: b.page ? {
      id: b.page.id,
      network: b.page.network,
      name: b.page.name,
      network_id: b.page.network_id,
      story_config: b.page.story_config,
      isGroup: b.page.isGroup,
      affected_to: b.page.affected_to
    } : b.page,
  }
}

export function slimSource(s) {
  if (!s || typeof s !== 'object') return s
  return s
  // return { id: s.id, name: s.name, domain: s.domain, category: s.category }
}

function logStorageSizes() {
  const sizes = Object.keys(_storage)
    .map(k => ({ key: k, size: (_get(k) || '').length * 2 }))
    .sort((a, b) => b.size - a.size)
  console.warn('[localStorage] Tailles :', sizes.map(s => `${s.key}: ${(s.size / 1024).toFixed(1)}KB`).join(', '))
}

function handleQuota(key, value) {
  console.warn('[localStorage] Quota dépassé')
  logStorageSizes()

  const isOnboarding = _get('onboarding_mode') === 'true'

  for (const tier of EVICTABLE_TIERS) {
    tier.forEach(k => {
      // Do not evict onboardingCompleted or onboardingSkipped ever
      if (['onboardingCompleted', 'onboardingSkipped'].includes(k)) return
      // Do not evict active onboarding keys if user is actively onboarding
      if (isOnboarding && EVICTABLE_TIERS[2].includes(k)) return
      Storage.prototype.removeItem.call(_storage, k)
    })
    try {
      _set(key, value)
      console.warn('[localStorage] Espace libéré (tier éviction)')
      return
    } catch {}
  }

  console.warn('[localStorage] Éviction totale, conservation des clés critiques')
  const saved = {}
  
  // Build dynamic list of critical keys to preserve
  const currentCriticalKeys = [...CRITICAL_KEYS, 'onboardingCompleted', 'onboardingSkipped']
  if (isOnboarding) {
    currentCriticalKeys.push(...EVICTABLE_TIERS[2])
  }

  currentCriticalKeys.forEach(k => {
    if (k === key) return
    const v = _get(k)
    if (v) saved[k] = v
  })
  Storage.prototype.clear.call(_storage)
  Object.entries(saved).forEach(([k, v]) => {
    try { _set(k, v) } catch { console.warn('[localStorage] Could not restore:', k) }
  })
  try {
    _set(key, value)
  } catch {
    console.error('[localStorage] Impossible d\'écrire après vidage total :', key)
  }
}

const SLIM_KEYS = {
  pages: (arr) => arr.map(slimPage),
  bots: (arr) => arr.map(slimBot),
  sources: (arr) => arr.map(slimSource),
}

function applySlim(key, value) {
  const fn = SLIM_KEYS[key]
  if (!fn || typeof value !== 'string') return value
  try {
    const parsed = JSON.parse(value)
    if (Array.isArray(parsed)) return JSON.stringify(fn(parsed))
  } catch {}
  return value
}

function customSetItem(key, value) {
  const slimmed = applySlim(key, value)
  try {
    _set(key, slimmed)
  } catch (e) {
    if (e.name !== 'QuotaExceededError') throw e
    try { handleQuota(key, slimmed) } catch { console.error('[localStorage] handleQuota failed:', key) }
  }
}

export function setupLocalStorageGuard() {
  const proxyHandler = {
    get(target, prop) {
      if (typeof prop === 'symbol') return Reflect.get(target, prop, target)
      if (prop === 'setItem') return customSetItem
      if (prop in Storage.prototype) {
        const val = target[prop]
        return typeof val === 'function' ? val.bind(target) : val
      }
      // Accès direct : localStorage.bots, localStorage.token…
      return _get(String(prop))
    },
    set(target, prop, value) {
      if (typeof prop === 'string' && !(prop in Storage.prototype)) {
        customSetItem(prop, value)
        return true
      }
      return Reflect.set(target, prop, value)
    },
  }

  try {
    Object.defineProperty(window, 'localStorage', {
      value: new Proxy(_storage, proxyHandler),
      configurable: true,
      enumerable: true,
      writable: true,
    })
  } catch {
    // Fallback : au moins setItem est protégé
    Storage.prototype.setItem = customSetItem
    console.warn('[localStorage] Proxy non supporté, fallback setItem uniquement')
  }
}
